'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _player = require('@vimeo/player');

var _player2 = _interopRequireDefault(_player);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _fabfitfunSharedUtils = require('@bit/fabfitfun.shared.utils.number-utils');

var _fabfitfunSharedUtils2 = require('@bit/fabfitfun.shared.utils.arg-types');

var _fabfitfunSharedUtils3 = _interopRequireDefault(_fabfitfunSharedUtils2);

require('./VideoPlayer.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Video Component for loading a single video player
 * @param {number} videoId - Id of the video that coorolates to the service provider
 */
var VideoPlayer = (_temp = _class = function (_Component) {
  _inherits(VideoPlayer, _Component);

  function VideoPlayer(props) {
    _classCallCheck(this, VideoPlayer);

    var _this = _possibleConstructorReturn(this, (VideoPlayer.__proto__ || Object.getPrototypeOf(VideoPlayer)).call(this, props));

    _this.state = Object.assign({}, props, {
      elementId: (0, _fabfitfunSharedUtils.uid)()
    });
    return _this;
  }

  _createClass(VideoPlayer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          videoId = _props.videoId,
          onStart = _props.onStart,
          onComplete = _props.onComplete,
          onLoad = _props.onLoad;
      var elementId = this.state.elementId;


      this.player = new _player2.default(elementId, {
        id: parseInt(videoId, 10)
      });

      if (onStart) {
        this.player.on('play', onStart);
      }

      if (onComplete) {
        this.player.on('ended', onComplete);
      }

      if (onLoad) {
        this.player.on('loaded', onLoad);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (nextProps.videoId != this.props.videoId) {
        this.player.loadVideo(nextProps.videoId).then(function () {
          _this2.player.play();
        }).catch(function (error) {
          switch (error.name) {
            case 'TypeError':
              // the id was not a number
              console.error('the video id was not a number');
              break;

            case 'PasswordError':
              // the video is password-protected and the viewer needs to enter the
              // password first
              console.error('Video is protected');
              break;

            case 'PrivacyError':
              // the video is password-protected or private
              console.error('Video is private');
              break;

            default:
              // some other error occurred
              console.error('Video load error', error);
              break;
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'player-container', style: Object.assign({}, this.props.style) },
        _react2.default.createElement('div', { className: 'responsify', id: this.state.elementId })
      );
    }
  }], [{
    key: 'getPlayer',
    value: function getPlayer() {
      return this.player;
    }
  }, {
    key: 'play',
    value: function play() {
      return this.player.play();
    }
  }, {
    key: 'pause',
    value: function pause() {
      return this.player.pause();
    }
  }, {
    key: 'on',
    value: function on(type) {}
  }, {
    key: 'loadVideo',
    value: function loadVideo(id) {
      return this.player.loadVideo(parseInt(id, 10));
    }
  }]);

  return VideoPlayer;
}(_react.Component), _class.defaultProps = {
  videoId: '255796847'
}, _temp);


VideoPlayer.propTypes = {
  videoId: _propTypes2.default.string,
  style: _propTypes2.default.object
};

VideoPlayer.defaultStyles = {
  maxWidth: '600px',
  width: '100%'
};

VideoPlayer.args = [{
  title: 'Vimeo Id',
  key: 'videoId',
  type: _fabfitfunSharedUtils3.default.STRING
}];

exports.default = VideoPlayer;

//# sourceMappingURL=VideoPlayer.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@bit/fabfitfun.shared.global.video-player/dist/VideoPlayer.js
// module id = 500
// module chunks = 0